<template>
  <v-container fluid>
    <v-snackbar
      v-model="snackbar"
      :color="snackbarColor"
      :top="true"
      :right="true"
      :timeout="-1"
      absolute
    >
      {{ message }}
      <v-btn
        dark
        text
        @click="snackbar = false"
      >
        CLOSE
      </v-btn>
    </v-snackbar>
    <v-row>
      <v-progress-circular v-show="approveloading || declineloading" color="secondary"
                class="accent--text logoutbtn" size="25"
                           indeterminate></v-progress-circular>
      <v-col cols="1">
        <h4 class="white--text"> Tax Types </h4>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="3" class="text-xs-right" v-if="canCreateTaxType">
        <v-btn color="#7BC243" @click="createTaxDialog" class="white--text cataloguebtn">Create Tax Type</v-btn>
        <v-progress-linear v-if="showProgressBar" indeterminate height="14" width="16"></v-progress-linear>
      </v-col>

    </v-row>
    <v-layout>
      <v-flex xs12>
        <div :class="paginatedFiles.length === 7 ? 'catalogue_box' : 'catalogue_box_empty'">
          <v-card-text>

            <v-layout>
              <v-flex xs3>
                <span class="accent--text" style="font-size: 14px; font-weight:700;"> </span>
              </v-flex>
              <v-spacer></v-spacer>
              <v-flex xs3>
                <v-text-field label="Search" v-model="search"></v-text-field>
              </v-flex>
            </v-layout>
            <v-progress-linear
              v-if="loading"
              indeterminate
              color="primary"
              height="4"
            ></v-progress-linear>

            <table class="table">
              <thead class="thead">
              <tr>
                <th scope="col">Name</th>
                <th scope="col">Rate</th>
                <th scope="col">Status</th>
                <th scope="col">Date</th>
                <th scope="col"></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="item in filteredList" :key="item.id">
                <td>{{ item.name }}</td>
                <td>{{ item.rate }}</td>
                <td :class="{
          'text-danger font-size-12 ': item.status.statusName === 'FAILED_VALIDATION',
          'text-warning font-size-12 ': item.status.statusName === 'FAILED_VALIDATION'
        }">
                  {{ item.status.statusName }}
                </td>
                <td>{{ item.dateCreated | prettyDate }}</td>
                <td class="actions">
                  <v-menu offset-y>
                    <template v-slot:activator="{ on }">
                      <v-btn color="primary" v-on="on" text icon class="actions">
                        <v-icon class="secondary--text"> more_horiz</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item v-if="item.status.id ===1 && canCreateTaxType" @click="editTaxType(item)">
                        <v-list-item-title> Edit</v-list-item-title>
                      </v-list-item>
                      <v-list-item v-if="item.status.id ===3 && canApproveTaxType" @click="confirmApproveRejectAction(item, 'Approve')">
                        <v-list-item-title>Approve</v-list-item-title>
                      </v-list-item>
                      <v-list-item v-if="item.status.id === 3 && canApproveTaxType" @click="confirmApproveRejectAction(item, 'Reject')">
                        <v-list-item-title> Reject</v-list-item-title>
                      </v-list-item>
                    </v-list>

                  </v-menu>
                </td>
              </tr>
              </tbody>
            </table>
          </v-card-text>

          <v-card-actions>
            <span class="paginationtext"> Showing {{ page }} of {{ numberOfLinks }} pages </span>
            <v-spacer></v-spacer>
            <v-pagination
              v-model="page"
              :length="numberOfLinks"
              :total-visible="7"
              color="secondary"
                class="accent--text logoutbtn"
            ></v-pagination>
          </v-card-actions>
        </div>
      </v-flex>
      <v-dialog v-model="createTaxTypeDialog" persistent max-width="850">
        <template>
          <v-card>
            <v-card-title class="headline accent&#45;&#45;text"
            >Create Tax Type</v-card-title
            >
            <v-card-text>
              <v-container grid-list-xl fluid>
                <v-form ref="form" v-model="valid" lazy-validation>
                  <v-layout wrap>
                    <v-flex xs12>
                      <v-text-field
                        label="Name"
                        min="1"
                        type="text"
                        v-model="taxname"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        label="Rate"
                        min="0"
                        type="number"
                        v-model="taxrate"
                      ></v-text-field>
                    </v-flex>

                  </v-layout>
                </v-form>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-btn
                color="white"
                class="accentd&#45;&#45;text"
                style="font-weight: 700"
                @click="createTaxTypeDialog = false"
              >Cancel</v-btn
              >

              <v-spacer></v-spacer>
              <v-btn color="secondary" @click="createTaxType"
              >Submit</v-btn
              >
              <v-progress-circular
                style="margin-left: 10px"
                v-show="create_loader"
                color="red"
                size="20"
                indeterminate
              ></v-progress-circular>
            </v-card-actions>
          </v-card>
        </template>
      </v-dialog>
      <v-dialog v-model="editTaxTypeDialog" persistent max-width="850">
        <template>
          <v-card>
            <v-card-title class="headline accent&#45;&#45;text"
            >Edit Tax Type</v-card-title
            >
            <v-card-text>
              <v-container grid-list-xl fluid>
                <v-form ref="form" v-model="valid" lazy-validation>
                  <v-layout wrap>
                    <v-flex xs12>
                      <v-text-field
                        label="Name"
                        min="1"
                        type="text"
                        v-model="taxname"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        label="Rate"
                        min="0"
                        type="number"
                        v-model="taxrate"
                      ></v-text-field>
                    </v-flex>

                  </v-layout>
                </v-form>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-btn
                color="white"
                class="accentd&#45;&#45;text"
                style="font-weight: 700"
                @click="editTaxTypeDialog = false"
              >Cancel</v-btn
              >

              <v-spacer></v-spacer>
              <v-btn color="secondary" @click="editTax"
              >Submit</v-btn
              >
              <v-progress-circular
                style="margin-left: 10px"
                v-show="create_loader"
                color="red"
                size="20"
                indeterminate
              ></v-progress-circular>
            </v-card-actions>
          </v-card>
        </template>
      </v-dialog>
      <v-dialog v-model="confirmApproveRejectDialog" max-width="400">
        <v-card>
          <v-card-title class="body-2 primary--text font-weight-bold text-capitalize">{{ this.action }} tax type
          </v-card-title>

          <v-card-text class="primary--text">
            {{ confirmMessage }}
          </v-card-text>

          <v-card-actions>
            <v-btn
              color="primary"
              text
              @click="confirmApproveRejectDialog = false"
              class="font-weight-bold"
            >
              Cancel
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              color="secondary"
              class="accent--text logoutbtn"
              @click="approveReject()"
            >
              Confirm
            </v-btn>
            <v-progress-circular
              style="margin-left: 10px"
              v-show="create_loader"
              color="red"
              size="20"
              indeterminate
            ></v-progress-circular>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>
<script>
import axios from 'axios'
import config from '../../../config'
import store from '../../../store'
import { Common } from '@/components/views/file/common'
import { mapState } from 'vuex'

export default {
	name: 'catalogueupload',
	data: function () {
		return {
			loading: false, // controls the progress bar visibilit
			previewItems: [],
			taxid: '',
			taxname: '',
			create_loader: false,
			taxrate: 0,
			valid: true,
			message: '',
			snackbar: false,
			snackbarColor: '',
			file: '',
			files: [],
			totalFiles: 0,
			downloadFileDialog: false,
			pagination: { sortBy: 'id', descending: true },
			search: '',
			expand: false,
			permissions: [],
			timerContent: true,
			previewLoading: false,
			approveloading: false,
			declineloading: false,
			paginatedFiles: [],
			numberOfLinks: 0,
			numberOfItemsPerPage: 10,
			// window.innerHeight <= 600 ? 6 : window.innerHeight > 600 && window.innerHeight <= 1000 ? 14 : 20,
			page: 1,
			currentPage: 0,
			confirmDialog: false,
			confirmApproveRejectDialog: false,
			confirmFile: {},
			confirmItem: {},
			confirmMessage: '',
			action: '',
			uploadFileDialog: false,
			remainingTime: 0, // Total time in days
			targetDate: '',
			days: 0,
			hours: 0,
			minutes: 0,
			seconds: 0,
			interval: null,
			saleNo: '',
			saleDate: '',
			isUploadDisabled: false,
			createTaxTypeDialog: false,
			editTaxTypeDialog: false,
			showProgressBar: false,
			uploadLoading: false,
			userID: 0
		}
	},
	mounted () {
		console.log(window.innerHeight)
		this.getTaxTypes(this.currentPage)
		this.permissions = store.state.user.roleId.permissions
		this.startCountdown()
	},
	beforeDestroy () {
		clearInterval(this.interval)
	},
	watch: {
		files () {
			this.paginatedFiles = this.files
		},
		page: function (val) {
			this.paginatedFiles = this.getTaxTypes(val - 1)
		}
	},
	computed: {
		...mapState({ user: (state) => state.user }),
		canCreateTaxType: function () {
			return this.hasPerm('CAN_CREATE_ORGANISATION')
		},
		canApproveTaxType: function () {
			return this.hasPerm('CAN_APPROVE_ORGANISATION')
		},
		filteredList: function () {
			if (this.search === '') {
				return this.paginatedFiles
			} else {
				return this.files.filter(file => {
					const searchTerm = this.search.toLowerCase()
					var dateCreated = new Date(file.created)
					return (
						(file.name.toLowerCase().includes(searchTerm)) ||
            file.status.statusName.toLowerCase().includes(searchTerm) ||
            file.createdBy.toLowerCase().includes(searchTerm) ||
            dateCreated.toDateString().toLowerCase().includes(searchTerm)
					)
				})
				// return this.files.filter(file => { return file.fileName.toLowerCase().includes(this.search.toLowerCase()) })
			}
		},
		userId: function () {
			if (this.user) {
				this.organisationType = this.user.organisation.organisationType.name
				this.organisationId = this.user.organisation.id
				this.userID = this.user.id
				this.username = this.user.username
				return this.user.id
			}
			return 0
		}
	},
	methods: {

		hasErrorFile (item) {
			return item.status.id === 88
		},
		canDownloadFile (item) {
			return item.status.id !== 88
		},
		startCountdown () {
			this.interval = setInterval(this.updateCountdown, 1000)
		},
		updateCountdown () {
			const now = new Date().getTime()
			const distance = this.targetDate - now

			if (distance < 0) {
				clearInterval(this.interval)
				this.isUploadDisabled = true
				this.days = 0
				this.hours = 0
				this.minutes = 0
				this.seconds = 0
				return
			}

			this.days = Math.floor(distance / (1000 * 60 * 60 * 24))
			this.hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
			this.minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
			this.seconds = Math.floor((distance % (1000 * 60)) / 1000)
		},

		editTaxType (item) {
			this.editTaxTypeDialog = true
			this.taxid = item.id
			this.taxname = item.name
			this.taxrate = item.rate
		},

		createTaxType () {
			console.log('this.sale')

			if (this.taxname === '' || this.taxrate === 0) {
				this.snackbar = true
				this.snackbarColor = 'error'
				this.message = 'Please enter all fields'
				return
			}
			this.create_loader = true
			const url = config.serverURI + '/taxtypes/save?name=' + this.taxname + '&rate=' + this.taxrate
			axios.post(url)
				.then(response => {
          console.log("res -> ", response)
					const message = response.data.message
					this.create_loader = false
					if (message === 'Success') {
						this.taxname = ''
						this.taxrate = 0
						this.createTaxTypeDialog = false
						this.getTaxTypes(this.currentPage)

						this.snackbar = true
						this.snackbarColor = 'primary'
						this.message = 'Successfully added tax type'
						return
					}
					this.snackbar = true
					this.snackbarColor = 'error'
					this.message = message
				})
				.catch(error => {
					console.log('error0 - ', error)
					this.create_loader = false
					this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: 'Error ocurred' })
				})
		},

		confirmApproveRejectAction (item, action) {
			this.taxid = item.id
			this.confirmApproveRejectDialog = true
			this.action = action
			if (action === 'Approve') {
				this.confirmMessage = 'Approve tax type ' + item.name + ' ?'
			} else if (action === 'Reject') {
				this.confirmMessage = 'Reject tax type ' + item.name + ' ?'
			} else {
				console.error(action + 'Action not supported')
			}
		},
		canBeApproved (item) {
			return (item.status.id === 3 || item.status.id === 23 || item.status.id === 90) && this.hasPerm('CAN_APPROVE_CATALOGUE')
		},
		canBeDeclined (item) {
			// console.log("Role",this.user.roleId.name)

			return (item.status.id === 3 || item.status.id === 90) && this.hasPerm('CAN_APPROVE_CATALOGUE') && this.user.roleId.name === 'MARKETER_CHECKER'
		},
		paginationMethod (items, pageNumber, limitPerPage) {
			pageNumber = pageNumber - 1
			const from = pageNumber * limitPerPage
			let to = (pageNumber + 1) * limitPerPage
			if (to >= items.length) {
				to = items.length
			}
			return items.slice(from, to)
		},
		hasPerm (permission) {
			return this.permissions.includes(permission)
		},
		handleFileUpload () {
			this.file = this.$refs.file.files[0]
		},
		approveReject () {
			this.create_loader = true
			const url = config.serverURI + '/taxtypes/confirm?id=' + this.taxid + '&action=' + this.action
			axios.put(url)
				.then(response => {
					const message = response.data.message
					this.create_loader = false
					if (message === 'Success') {
						this.taxname = ''
						this.taxrate = 0
						this.confirmApproveRejectDialog = false
						this.getTaxTypes(this.currentPage)

						this.snackbar = true
						this.snackbarColor = 'primary'
						this.message = 'Successfully ' + this.action + ' tax type'
						return
					}
					this.snackbar = true
					this.snackbarColor = 'error'
					this.message = 'Problem approving/rejecting tax type'
				})
				.catch(error => {
					console.log('error - ', error)
					this.create_loader = false
					this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: 'Error ocurred' })
				})
		},
		editTax () {
      if (this.taxname === '' || this.taxrate === 0) {
        this.snackbar = true
        this.snackbarColor = 'error'
        this.message = 'Please enter all fields'
        return
      }
			this.create_loader = true
			const url = config.serverURI + '/taxtypes/edit?id=' + this.taxid + '&name=' + this.taxname + '&rate=' + this.taxrate
			axios.put(url)
				.then(response => {
					const message = response.data.message
					this.create_loader = false
					if (message === 'Success') {
						this.taxname = ''
						this.taxrate = 0
						this.editTaxTypeDialog = false
						this.getTaxTypes(this.currentPage)

						this.snackbar = true
						this.snackbarColor = 'primary'
						this.message = 'Successfully edited tax type'
						return
					}
					this.snackbar = true
					this.snackbarColor = 'error'
					this.message = 'Problem adding tax type'
				})
				.catch(error => {
					console.log('error - ', error)
					this.create_loader = false
					this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: 'Error ocurred' })
				})
		},
		getTaxTypes (page) {
			var url = config.serverURI + '/taxtypes/getAll?page=' + page + '&size=' + this.numberOfItemsPerPage + '&paginate=Y'
			this.loading = true // Show progress bar
			axios.get(url)
				.then(response => {
					this.loading = false
					this.files = response.data.content
					this.numberOfLinks = response.data.page.totalPages
					this.numberOfItemsPerPage = response.data.page.size
					this.currentPage = response.data.page.number
				})
				.catch(error => {
					this.loading = false

					// Request failed.
					console.log('error', error.response)
				})
			return this.files
		},
		createTaxDialog () {
			this.createTaxTypeDialog = true
		}
	}
}

</script>
<style>
.catalogue_box_empty {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}

.catalogue_box {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}

.catalogue_box:after, .catalogue_box:before {
  right: 100%;
  top: 17%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

.catalogue_box:after {
  border-color: rgba(255, 255, 255, 0);
  border-right-color: #fff;
  border-width: 20px;
  margin-top: -20px;
}

.catalogue_box:before {
  border-color: rgba(112, 112, 112, 0);
  border-right-color: #707070;
  border-width: 21px;
  margin-top: -21px;
}

.thead {
  background-color: #00513B !important;
  color: white;
  font-size: 12px;
}

.table tbody tr > td.actions {
  font-size: 20px !important;
  color: #733D29 !important;
  padding-top: 0px;
}

.pagination {
  background-color: red;
}

.paginationtext {
  color: #733D29;
}

.pagination > li > a,
.pagination > li > span {
  border: 1px solid #F2D0A7;
  color: #733D29;
}

.pagination > li.active > .page-link {
  background: #00513B;
  color: #fff;
}
</style>
